// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { create } from 'zustand'
import type { SessionRole } from '@/types'

interface SessionState {
  sessionToken:   string | null
  userId:         string | null
  sessionRole:    SessionRole | null
  expiresAt:      string | null
  correctionOpen: boolean
  isActive:       boolean

  // Actions
  setSession: (
    sessionTokenOrParams: string | { sessionToken: string; userId: string; sessionRole: SessionRole; expiresAt: string },
    userId?: string,
    expiresAt?: string,
  ) => void
  clearSession:          () => void
  updateExpiry:          (expiresAt: string) => void
  setCorrectionWindow:   (open: boolean) => void
}

export const useSessionStore = create<SessionState>((set) => ({
  sessionToken:   null,
  userId:         null,
  sessionRole:    null,
  expiresAt:      null,
  correctionOpen: false,
  isActive:       false,

  setSession: (sessionTokenOrParams, userId, expiresAt) => {
    if (typeof sessionTokenOrParams === 'object') {
      const { sessionToken, userId: uid, sessionRole, expiresAt: exp } = sessionTokenOrParams
      set({ sessionToken, userId: uid, sessionRole, expiresAt: exp, isActive: true })
    } else {
      // Simple overload: setSession(token, userId, expiresAt)
      set({
        sessionToken: sessionTokenOrParams,
        userId:       userId ?? null,
        sessionRole:  'TRUSTED_PERSON' as SessionRole,
        expiresAt:    expiresAt ?? null,
        isActive:     true,
      })
    }
  },

  clearSession: () =>
    set({
      sessionToken:   null,
      userId:         null,
      sessionRole:    null,
      expiresAt:      null,
      correctionOpen: false,
      isActive:       false,
    }),

  updateExpiry: (expiresAt) =>
    set({ expiresAt }),

  setCorrectionWindow: (open) =>
    set({ correctionOpen: open }),
}))
